import { apiUrl } from "../../settings";

export const logoutUrl = () => {
    return apiUrl + '/logout';
};

